import React, { FC } from "react";
import { Trans, withTranslation } from "react-i18next";

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";

import { Section, List } from "shared/components";
import profile from "assets/images/profile.jpg";
import { commonStyles } from "theme/common";

type AboutProps = {};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  imageContainer: {
    display: "flex",
    justifyContent: "center",
  },
  ...commonStyles(theme),
}));

const About: FC<AboutProps> = () => {
  const classes = useStyles();

  return (
    <Section id="about" title={<Trans i18nKey="ABOUT.TITLE" />}>
      <Box>
        <Box display="flex">
          <Grid container className={classes.spacing4}>
            <Grid item xs={12} md={3}>
              <Box className={classes.imageContainer}>
                <img src={profile} alt="profile" height={200} width={134.75} />
              </Box>
            </Grid>
            <Grid item xs={12} md={9}>
              <Box className={classes.mb2}>
                <Typography variant="body1" className={classes.title}>
                  <Trans i18nKey="ABOUT.PROFILE_1" />
                </Typography>
                <Box className={classes.mt1}>
                  <Typography variant="body1" className={classes.title}>
                    <Trans i18nKey="ABOUT.PROFILE_2" />
                  </Typography>
                </Box>
                <Box className={classes.mt1}>
                  <List
                    title={<Trans i18nKey="ABOUT.PROFILE_3" />}
                    items={[
                      <Trans i18nKey="ABOUT.PROFILE_4" />,
                      <Trans i18nKey="ABOUT.PROFILE_5" />,
                    ]}
                  />
                </Box>
                <Box className={classes.mt1}>
                  <List
                    title={<Trans i18nKey="ABOUT.DEGREE_TITLE" />}
                    items={[
                      <Trans i18nKey="ABOUT.DEGREE_1" />,
                      <Trans i18nKey="ABOUT.DEGREE_2" />,
                    ]}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Section>
  );
};

export default withTranslation()(About);
